import axios from 'axios';
import {get} from 'lodash';
import * as types from '../mutation-types';

export interface TuroResearchState {
    init: boolean;
    loading: Record<string, boolean>;
    locations: any[];
    makes: any[];
    researchList: any[];
}

const state: TuroResearchState = {
    init: false,

    loading: {
        locations: false,
        makes: false,
        research: false,
    },
    locations: [],
    makes: [],
    researchList: [],
};

const getters = {
    turoInit: (state: TuroResearchState) => state.init,
    loading: (state: TuroResearchState) => state.loading,
    locations: (state: TuroResearchState) => state.locations,
    makes: (state: TuroResearchState) => state.makes,
    researchList: (state: TuroResearchState) => state.researchList,
};

const mutations = {
    [types.SET_INIT](state: TuroResearchState, init: boolean) {
        state.init = init;
    },
    [types.SET_TURO_RESEARCH_LOADING](state: TuroResearchState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
    [types.SET_TURO_ALL_VEHICLE_MAKES](state: TuroResearchState, makes) {
        state.makes = makes;
    },
    [types.SET_TURO_ALL_DELIVERY_LOCATIONS](state: TuroResearchState, locations) {
        state.locations = locations;
    },
    [types.SET_TURO_RESEARCH_SEARCH_LIST](state: TuroResearchState, list) {
        state.researchList = list;
    },
};

const actions = {

    /**
     * Fetch delivery locations
     *
     * @param commit
     * @param rootGetters
     */
    fetchDeliveryLocations({commit, rootGetters}) {
        commit('SET_TURO_RESEARCH_LOADING', {subject: 'locations', loading: true});

        axios.get(`/v1/company/${rootGetters['company/company'].uuid}/connections/turo/delivery-locations`)
            .then((response) => {
                commit('SET_TURO_ALL_DELIVERY_LOCATIONS', get(response, 'data.locations'));
            }).catch((e) => {
            console.dir(e);
        }).finally(() => {
            commit('SET_TURO_RESEARCH_LOADING', {subject: 'locations', loading: false});
        });
    },


    /**
     * Fetch makes
     *
     * @param commit
     * @param rootGetters
     */
    fetchMakes({commit, rootGetters}) {
        commit('SET_TURO_RESEARCH_LOADING', {subject: 'makes', loading: true});

        axios.get(`/v1/company/${rootGetters['company/company'].uuid}/connections/turo/fetch-makes`)
            .then((response) => {
                commit('SET_TURO_ALL_VEHICLE_MAKES', get(response, 'data.makes'));
            }).catch((e) => {
            console.dir(e);
        }).finally(() => {
            commit('SET_TURO_RESEARCH_LOADING', {subject: 'makes', loading: false});
        });
    },


    /**
     * Start Turo research
     */
    startResearch({commit, rootGetters}, data) {
        commit('SET_TURO_RESEARCH_LOADING', {subject: 'research', loading: true});

        axios.post(`/v1/company/${rootGetters['company/company'].uuid}/connections/turo/research`, data)
            .then((response) => {
                commit('SET_TURO_RESEARCH_SEARCH_LIST', get(response, 'data.list.list'));
            }).catch((e) => {
            console.dir(e);
        }).finally(() => {
            commit('SET_TURO_RESEARCH_LOADING', {subject: 'research', loading: false});
        });
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
